<template>
<div class="LotteryEventDetails">
    <el-form ref="form" :model="form" label-width="110px" label-position="left">
        <div class="item">
            <header><p>基本信息</p></header>
                <el-form-item label="活动名称">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="活动简介">
                    <el-input type="textarea" v-model="form.subtitle"></el-input>
                </el-form-item>
                <el-form-item label="活动封面">
                <img class="fm" :src="form.coveratturlid" :alt="form.title">
                </el-form-item>
                <el-form-item label="活动时间段">
                    <el-input v-model="form.begintime"></el-input>
                </el-form-item>
                <el-form-item label="活动详情">
                    <div class="ueditorBox">
                        <uEditor :content="form.eventdesp" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                    </div>
                </el-form-item>
        </div>
        <div class="item" v-for="(item, index) in form.luckdraweventlevelinfo" :key="index">
            <header>
                <p>奖项信息</p>
            </header>
            <el-form-item label="奖项名称">
                <el-input v-model="item.name"></el-input>
            </el-form-item>
            <el-form-item label="奖品类型">
                <el-radio-group v-model="item.prizetype" disabled>
                    <el-radio :label=1>实物</el-radio>
                    <el-radio :label=2>红包</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品份数" v-if="item.prizetype === 1">
                <el-input v-model="item.prizecount"></el-input>
            </el-form-item>
            <el-form-item label="红包类型" v-if="item.prizetype === 2">
                <el-radio-group v-model="item.packettype" disabled>
                    <el-radio :label=1>普通红包</el-radio>
                    <el-radio :label=2>拼手气红包</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="单个红包金额" v-if="item.prizetype === 2 && item.packettype === 1">
                <el-input v-model="item.singlepacketmoney"></el-input>
            </el-form-item>
            <el-form-item label="红包总金额" v-if="item.prizetype === 2 && item.packettype === 2">
                <el-input v-model="item.totalpacketmoney"></el-input>
            </el-form-item>
            <el-form-item label="红包总数量" v-if="item.prizetype === 2">
                <el-input v-model="item.totalawardcount"></el-input>
            </el-form-item>
            <el-form-item label="奖项说明" v-if="item.memo">
                <el-input v-model="item.memo"></el-input>
            </el-form-item>
        </div>
        <div class="item">
            <header>
                <p>抽奖设置</p>
            </header>
            <el-form-item label="可参与次数">
                <el-input v-model="form.maxjoincount"></el-input>
            </el-form-item>
            <el-form-item label="可重复参与抽奖">
                <el-input v-model="form.jointypetext"></el-input>
            </el-form-item>
            <el-form-item label="参与条件">
                <el-radio-group v-model="form.jointype" disabled>
                    <el-radio :label=1>无条件参与</el-radio>
                    <el-radio :label=2>分享解锁参与</el-radio>
                    <el-radio :label=3>付费参与</el-radio>
                    <el-radio :label=4>组队参与</el-radio>
                    <el-radio :label=5>口令参与</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="付费金额" v-if="form.jointype === 3">
                <el-input v-model="form.joinmoney" ></el-input>
            </el-form-item>
            <el-form-item label="组团人数" v-if="form.jointype === 4">
                <el-input v-model="form.groupcount" ></el-input>
            </el-form-item>
            <el-form-item label="参与口令" v-if="form.jointype === 5">
                <el-input v-model="form.joinpass" ></el-input>
            </el-form-item>
            <el-form-item label="开奖条件">
                <el-input v-model="form.opentypepetext"></el-input>
            </el-form-item>
            <el-form-item label="开奖指定时间">
                <el-input v-model="form.openawardtime"></el-input>
            </el-form-item>
            <el-form-item label="开奖指定人数" v-if="form.openminjoincount">
                <el-input v-model="form.openminjoincount"></el-input>
            </el-form-item>
            <el-form-item label="开奖人数上限" v-if="form.openmaxjoincount">
                <el-input v-model="form.openmaxjoincount"></el-input>
            </el-form-item>
            <el-form-item label="抽奖方式">
                <el-radio-group v-model="form.drawstyletype" disabled>
                    <el-radio :label=1>转盘</el-radio>
                    <el-radio :label=2>九宫格</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品发放方式">
                <el-radio-group v-model="form.awardsendtype" disabled>
                    <el-radio :label=1>联系客服</el-radio>
                    <el-radio :label=2>线上领取</el-radio>
                    <el-radio :label=4>现场核销</el-radio>
                    <el-radio :label=5>按地址发货</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品领取地址" v-if="form.awardsendtype === 2">
                <el-input v-model="form.awardlinkurl"></el-input>
            </el-form-item>
        </div>
        <div class="set-up item">
            <header>
                <p>活动设置</p>
            </header>
            <el-form-item label="传播隐私设置">
                <el-input v-model="form.sharetype"></el-input>
            </el-form-item>
            <el-form-item label="留言设置">
                <el-input v-model="form.commentpritype"></el-input>
            </el-form-item>
            <el-form-item label="参与有奖励">
                <div class="min">
                    <span>奖励总金额</span>
                    <el-input v-model="form.joinawardtotalmoney"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.joinawardtotalcount"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="分享有奖励">
                <div class="min">
                    <span>单个奖励金额</span>
                    <el-input v-model="form.shareawardtotalcount"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.shareawardsinglemoney"></el-input>
                </div>
            </el-form-item>
        </div>
    </el-form>
</div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import UEditor from 'base/uEditor/uEditor'
import { getLuckDrawEventDetail } from 'api/operateToolApi'
export default {
    name: 'LotteryEventDetails',
    data() {
        return {
            eventinnerid: this.$route.query.eventinnerid, // 活动ID
            form: {
                    title:'', // 活动标题
                    subtitle:'', //  活动简介
                    coveratturlid:'', //  活动Logo图对象
                    begintime:'', //  活动开始时间
                    endtime:'', //  活动结束时间
                    eventdesp:'', //  活动详情
                    eventplace:'', //  活动地点
                    jointype: '', // 参与方式
                    status:'', //  活动状态 0, 待发布 10, 进行中  11, 暂停中  30, 已完成  100,已取消
                    //互动信息
                    eventformlist: [    //  签到表单list
                        {
                            colindex:'', //   序号
                            colinnerid:'', //   表单InnerID
                            colname:'', //   字段名称
                            coltype:'', //   字段类型：1 单行文本框 2 数字文本框 3 日期选择框 4 邮箱输入框 5 多行文本框 6 单选按钮框 7 多选按钮框 8 下拉选择框
                            placeholder:'', //   字段提示语
                            optionsinfo:'', //   下拉选项表：多个以逗号隔开
                            ispublic:'', //   是否公开
                            isnotnull:'', //   是否必填
                        }
                    ],

                    //活动设置
                    sharetype:'', //   传播隐私设置 1所有人均可转发  2只有发布者可以转发
                    isopencomment:'', //   留言设置  0否 1是
                    isjoinaward:'', //   是否参与奖励 0否 1是
                    joinawardtotalmoney:'', //   参与奖励总金额
                    joinawardtotalcount:'', //   参与奖励总个数
                    isshareaward:'', //   是否分享奖励 0否 1是
                    shareawardtotalcount:'', //   分享奖励总个数
                    shareawardsinglemoney:'', //   分享奖励单个金额"
                },
        }
    },
    mounted() {
       this.setLoading(true)
        getLuckDrawEventDetail({
            data: {eventinnerid: this.eventinnerid},
            success: data => {
                this.setLoading(false)
                this.form = Object.assign({}, data.data.eventinfo, data.data.luckdraweventsettinginfo, {luckdraweventlevelinfo: data.data.luckdraweventlevelinfo}, data.data.mpeventsettinginfo)
                console.log(this.form)
                if (this.form.maxjoincount === 0 || this.form.maxjoincount === '') {
                    this.form.maxjoincount = '无限制'
                }
                this.form.begintime = `${this.form.begintime} 至 ${this.form.endtime}`
                 // 活动详情渲染
                this.$refs.uEditor.init(this.form.eventdesp)

                for (let i = 0; i < this.form.eventformlist.length; i++) {

                    if (this.form.eventformlist[i].coltype == 6 || this.form.eventformlist[i].coltype == 7 || this.form.eventformlist[i].coltype == 8) {

                        let data = [],
                            optionsinfo = this.form.eventformlist[i].optionsinfo,
                            optionsinfoItem = optionsinfo.split(',')

                        for (let j = 0; j < optionsinfoItem.length; j++) {
                            data.push({value: optionsinfoItem[j]})
                        }

                        this.form.eventformlist[i].optionsinfo = data
                    }
                }
                // this.form.eventformlist.unshift({ //  表单list
                //     colinnerid: '', // 表单InnerID
                //     colname: '姓名', // 字段名称
                //     colindex: '', // 序号
                //     coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //     placeholder: '', // 字段提示语
                //     optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //     isnotnull: 1, // 是否必填"
                //     ispublic: 0,   // 是否公开
                //     },
                //     { //  表单list
                //         colinnerid: '', // 表单InnerID
                //         colname: '手机', // 字段名称
                //         colindex: '', // 序号
                //         coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //         placeholder: '', // 字段提示语
                //         optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //         isnotnull: 1, // 是否必填"
                //         ispublic: 0,   // 是否公开
                //     }
                // )
                this.$nextTick(() => {
                    this.form = JSON.parse(JSON.stringify(this.form))
                })

            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    },
    methods: {
        // 详情信息
        getUEditorContent(content) {
            this.form.eventdesp = content
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        UEditor
    }
}
</script>


<style lang="scss" type="text/scss">
.LotteryEventDetails {
    .item {
        margin-bottom: 20px;
        border-bottom: solid 1px #eee;
    }
    .ue_btn {
        display: none;
    }
    .el-textarea {
        width: 400px;
        height: 80px;

        .el-input {
            height: 100%;
        }
    }
    .el-input {
        max-width: 400px;

        input {
            width: 100%;
        }
    }
    .time {
        .el-input {
            max-width: 268px;
            margin-bottom: 20px;
            max-width: 268px;
        }
    }

    .sign-in {
        .el-input {
            display: block;
            max-width: 128px;
        }

        .list {
            .el-input {
                margin-top: 20px;
                display: block;
                max-width: 277px;
            }
        }

    }
    .set-up {
        .min {
            .el-input {
                margin: 0 20px;
                max-width: 116px;
            }
        }

    }

    .fm {
        display: block;
        width: 318px;
        height: 178px;
        border-radius: 4px;
    }
    header {
        height: 60px;
        p {
            padding-left: 20px;
            font-size: 16px;
            color: #333;
            border-left: solid 2px #409eff
        }
    }
}
</style>
